import { render } from "./CreateSubscription.vue?vue&type=template&id=2dc3f7f6&ts=true"
import script from "./CreateSubscription.vue?vue&type=script&lang=ts"
export * from "./CreateSubscription.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__